import { PlusOutlined } from '@ant-design/icons';
import { Typography } from 'antd';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AlumlyButton from '../../../components/AlumlyButton';
import { NotificationEnum } from '../../../enums/notification';
import { PermissionEnum } from '../../../enums/permission';
import { RouteNameEnum } from '../../../enums/routeName';
import usePermission from '../../../hooks/usePermission';
import NotificationList from '../components/NotificationList';

const Notification: React.FC = () => {
  const navigate = useNavigate();
  const { checkPermission } = usePermission();
  const [index] = useState(0);

  return (
    <div>
      <Typography.Title level={4} style={{ fontWeight: 'bold', margin: 0 }}>Notification list</Typography.Title>
      <div style={{
        marginTop: 32,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
      }}
      >
        {(
          index === NotificationEnum.tabIndex.list
          && checkPermission([PermissionEnum.code.notificationCreate])
        )
         && (
         <AlumlyButton
           icon={<PlusOutlined />}
           width={220}
           onClick={() => navigate(RouteNameEnum.notification.create)}
         >
           Create notification
         </AlumlyButton>
         )}
      </div>
      {index === NotificationEnum.tabIndex.list && <NotificationList />}
    </div>
  );
};

export default Notification;
